import * as React from 'react';

const Pencil24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M17.116 3.35a1.25 1.25 0 0 1 1.768 0l2.293 2.292a1.25 1.25 0 0 1 0 1.768L8.53 20.057a.75.75 0 0 1-.348.197l-4 1a.75.75 0 0 1-.91-.91l1-4a.75.75 0 0 1 .198-.348zm-1.055 3.176L18 8.466l1.94-1.94L18 4.587l-1.94 1.94Zm.878 3L15 7.587 5.677 16.91l-.646 2.585 2.586-.646z"
  }
));
Pencil24.Size = 24;
Pencil24.Title = "Pencil";

export { Pencil24 as default };
